export default __webpack_public_path__ + "static/media/Wolf's Straps of the Ritual Flame.4c917cb7.jpg";